export default {
  new_tag: 'Ny',
  groups: {
    dashboards: 'Dashboards',
    online_shop: 'Onlinebutik',
    home: 'Hjem',
    marketing: 'Marketing',
    reservations: 'Reservationer',
    website: 'Hjemmeside',
    orders_portal: 'Åbn ordreportal',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Mobilapp',
    phone_answering: 'Telefonbetjening',
    pricing: 'Priser',
    team: 'Team',
    data_deletion_requests: 'Anmodninger om sletning af data',
    partner: 'Partner',
  },
  get_started: {
    title: 'Kom i gang',
  },
  onboarding: {
    title: 'Lancér',
  },
  new_restaurant: {
    title: 'Ny restaurant',
  },
  gift_cards: {
    title: 'Gavekort',
  },
  top_items: {
    title: 'Topvarer',
  },
  dashboards: {
    title: 'Dashboards',
    children: {
      general: 'Generelt',
      restaurant_details: 'Restaurantoplysninger',
      external_delivery: 'Ekstern levering',
      overview: 'Overblik',
      orders: 'Ordrer efter kilde',
      google: 'Google',
      customers: 'Kunder',
    },
  },
  customer_base: {
    title: 'Kundebase',
  },
  new_company: {
    title: 'Ny restaurant',
  },
  agent_ops_queue: {
    title: 'AI-forslag',
  },
  external_delivery_support: {
    title: 'Support til ekstern levering',
  },
  payment_gateways: {
    title: 'Betalingsgateways',
  },
  developers: {
    title: 'Udviklere',
  },
  feature_flags: {
    title: 'Feature flags',
  },
  platform_agent_log: {
    title: 'Amigo-log',
  },
  test_restaurants: {
    title: 'Testrestauranter',
  },
  partners: {
    title: 'Partnere',
  },
  partner: {
    children: {
      account: 'Konto',
      branding: 'Branding',
      payment_gateway: 'Betalingsgateway',
      billing: 'Fakturering',
      tax_currency: 'Skat og valuta',
      service_fee_calculator: 'Servicegebyrberegner',
      processing_fees: 'Betalingsgebyrer',
    },
  },
  going_live: {
    title: 'Go live',
    children: {
      setup_package_fulfillments: 'Logsta-leverancer',
      polygraphy: 'Trykprodukter',
    },
  },
  franchises: {
    title: 'Brands',
  },
  setup_package_fulfillments: {
    title: 'Leverancer af opsætningspakke',
  },
  website: {
    title: 'Hjemmeside',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reservation',
    children: {
      overview: 'Overblik',
      booking_availability: 'Bordtilgængelighed',
      settings: 'Indstillinger',
      general: 'Generelt',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Abonnementer',
    children: {
      subscriptions: 'Abonnementer',
      products: 'Produkter',
    },
  },
  sales: {
    title: 'Salg',
    children: {
      orders: 'Ordrer',
      receipts: 'Kundekvitteringer',
      external_deliveries: 'Eksterne leverancer',
    },
  },
  billing: {
    title: 'Rapporter',
    children: {
      monthly_statements: 'Månedsopgørelser',
      payouts: 'Udbetalinger',
      invoices: 'Fakturaer',
      subscription: 'Abonnement',
      sales_summary: 'Salgsoversigt',
      internal_invoice_items: 'Interne fakturaposter',
      income_reports: 'Indtægtsrapporter',
      tax_reports: 'Skatterapporter',
    },
  },
  master_menu: {
    title: 'Brandsynkronisering',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Brands',
      manage_menus: 'Administrer menuer',
      modifiers: 'Tilvalg',
      smart_pricing: 'Smart prissætning',
      upsell_items: 'Mersalgsprodukter',
      sold_out_items: 'Udsolgte produkter',
      import: 'Importér',
      edit_history: 'Redigeringshistorik',
    },
  },
  my_store: {
    title: 'Mine oplysninger',
    children: {
      settings: 'Profil',
      gallery: 'Galleri',
      business_information: 'Virksomhedsoplysninger',
      documents: 'Mine dokumenter',
      personal_information: 'Personlige oplysninger',
      bank_info: 'Bankoplysninger',
      tax_info: 'Skatteoplysninger',
      shipping_info: 'Leveringsoplysninger',
      google_profile: 'Google-profil',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Impressum',
      post_launch: 'Efter lancering',
      tax_currency: 'Skat og valuta',
    },
  },
  opening_hours: {
    title: 'Åbningstider og placering',
    children: {
      opening_hours: 'Åbningstider',
      location: 'Placering',
    },
  },
  order_settings: {
    title: 'Ordreindstillinger',
    children: {
      takeout: 'Bestillingsmetoder',
      missed_orders: 'Mistede ordrer',
      order_layout: 'Ordrelayout',
      payment_methods: 'Betalingsmetoder',
      connect_paypal: 'Tilslut PayPal',
      tips: 'Drikkepenge',
      service_fee: 'Gebyrer',
      processing_fees: 'Betalingsgebyrer',
      receipt: 'Kvittering',
      staff_credentials: 'Personaleoplysninger',
      integrations: 'Integrationer',
      terminal: 'Terminal',
      invoices: 'Fakturaer',
    },
  },
  mobile_app: {
    title: 'Mobilapp',
    children: {
      overview: 'Overblik',
      updates: 'Opdateringer',
      intro_screen: 'Introskærm',
    },
  },
  marketing: {
    children: {
      overview: 'Overblik',
      followers: 'Følgere',
      email_messages: 'E-mailbeskeder',
      push_notifications: 'Pushnotifikationer',
      promo_codes: 'Rabatkoder',
      offers: 'Tilbud',
      google_business: 'Google Business',
      google_review_program: 'Google-anmeldelsesprogram',
      loyalty_program: 'Loyalitetsprogram',
      polygraphy: 'Trykprodukter',
      tracking_links: 'Sporingslinks',
      google_ads: 'Google Ads',
      website_analytics: 'Webstedsanalyse',
      featured_posts: 'Opslag i mobilapp',
    },
  },
  loyalty_tablet: {
    title: 'Loyalitetstablet',
    children: {
      dashboard: 'Dashboard',
      settings: 'Indstillinger',
      credentials: 'Loginoplysninger',
    },
  },
  contract: {
    title: 'Kontrakt',
    children: {
      agreement: 'Aftale',
      template: 'Skabelon',
    },
  },
  team: {
    children: {
      managers: 'Managere',
      reports: 'Rapporter',
    },
  },
};
